import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { ProductListType, ProductType } from "../types/types";
import { PRODUCTS_STORE } from "../constants/constant";

const initialProductsState = {
  products: [],
  isProductsAvailable: false,
  isPastPoliciesAvailable: false,
  hasSingleProduct: false,
};

export const useProductsStore = create(
  devtools(
    persist<ProductListType>(
      (set) => ({
        ...initialProductsState,
        setProducts: async (data: any) => {
          try {
            set(() => ({
              products: data,
              isProductsAvailable: data.some(
                (product: ProductType) => !product?.active_policies?.length
              ),
              hasSingleProduct: data.length === 1,
            }));
          } catch (err: any) {
            const error = err || "Unexpected error.";
            throw error;
          }
        },
        setIsPastPoliciesAvailable: (available: boolean) => {
          set(() => ({
            isPastPoliciesAvailable: available,
          }));
        },
        clearProducts: () => {
          set(() => ({
            products: [],
            hasSingleProduct: false,
          }));
        },
        clearProductsStore: () => {
          set(() => initialProductsState);
        },
      }),
      {
        name: PRODUCTS_STORE,
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
